import { BaseRoles, RoleVariantEnum } from 'common/graphql/types';
import { preloadLazyComponent } from 'common/utils/useLoading';
import { getFxEnabledRoles } from 'common/utils/user';

export const ACTIVITY_BUILDER_PATH = '/activitybuilder/:activityId/:activityDesignerTab?';
export const ACTIVITY_TRANSLATE_PATH = '/activitybuilder/:activityId/translate/:targetLng/:activityTranslateTab?';

export const routes = [
    {
        component: preloadLazyComponent(() => import('module/activitybuilder/datamapping.page')),
        permissions: ['Customer_Read'],
        role: [
            BaseRoles.AdminId,
            BaseRoles.UserId,
            RoleVariantEnum.StudyBuilder,
            RoleVariantEnum.StudySupport,
            RoleVariantEnum.AdminReadOnly,
            ...getFxEnabledRoles(),
        ],
        path: '/:activityId/datamapping',
    },
    {
        component: preloadLazyComponent(() => import('module/activitybuilder/activitybuilder.page')),
        permissions: ['Customer_Read'],
        role: [
            BaseRoles.AdminId,
            BaseRoles.UserId,
            RoleVariantEnum.StudyBuilder,
            RoleVariantEnum.StudySupport,
            RoleVariantEnum.SiteInvestigator,
            RoleVariantEnum.SiteCoordinator,
            RoleVariantEnum.Librarian,
            RoleVariantEnum.AdminReadOnly,
            ...getFxEnabledRoles(),
        ],
        path: '/:activityId/:activityDesignerTab?',
    },
    {
        component: preloadLazyComponent(() => import('module/activitybuilder/activitytranslate.page')),
        permissions: ['Customer_Read'],
        role: [
            BaseRoles.AdminId,
            BaseRoles.UserId,
            RoleVariantEnum.SiteInvestigator,
            RoleVariantEnum.StudySupport,
            RoleVariantEnum.SiteCoordinator,
            RoleVariantEnum.TranslationRepresentative,
            RoleVariantEnum.AdminReadOnly,
            ...getFxEnabledRoles(),
        ],
        path: '/:activityId/translate/:targetLng/:activityTranslateTab?',
    },
];
